import styled from 'styled-components';

export const MainMenuWrapper = styled.div`
  flex-wrap: nowrap;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 256px;
  flex-direction: column;
  width: inherit;
`;
